import {
  DocumentService,
  Fragment,
  FragmentIndexer,
  FragmentService,
  FragmentType,
  ManagedSubscriber,
  UUID
} from '@nh/angular-tses';
import {DepartureFragment} from '../types/departure-fragment';
import {dasFragmentIndexer} from './das-fragment-indexer';

export class DasFragmentIndexService extends ManagedSubscriber implements FragmentIndexer {
  // Map from fragmentId to display index
  private indexLookup: Record<string, string> = {};

  constructor(private _fragmentService: FragmentService, private _documentService: DocumentService) {
    super();
    this._fragmentService.onCreate(this._generateLookup.bind(this), this._reindexPredicate.bind(this));
    this._fragmentService.onUpdate(this._generateLookup.bind(this), this._reindexPredicate.bind(this));
    this._fragmentService.onDelete(this._generateLookup.bind(this), this._reindexPredicate.bind(this));
    this._documentService.onSelection(this._generateLookup.bind(this));
  }

  /**
   * Re-generates the lookup from fragment id to it's display index.
   */
  private _generateLookup(): void {
    const departureFragment: DepartureFragment = this._documentService.getSelected() as DepartureFragment;

    this.indexLookup = dasFragmentIndexer(departureFragment);
  }

  /**
   * For a given fragment or fragment id, return the display index.  If the display index is null, the default value is returned.
   *
   * @param arg {UUID|Fragment}   The fragment id or fragment data object
   * @param defaultValue {string} The default display index to display if no index is found. Defaults to the empty string.
   * @returns   {string}          The display index
   */
  public getIndex(arg: UUID): string {
    return this.indexLookup[arg.value] || '';
  }

  private _reindexPredicate(fragment: Fragment): boolean {
    return fragment.is(FragmentType.SECTION, FragmentType.CLAUSE) || fragment.isCaptioned();
  }
}
